import React from 'react';
import TooltipDropdownMenu from '@sfly/uig-tooltip-dropdown-menu'
// import Edit from '@sfly/uig-svg-icon/edit/edit';
// import Delete from '@sfly/uig-svg-icon/action/delete';
import EditIcon from './../../../../components/Icons/edit/edit';
import DeleteIcon from './../../../../components/Icons/delete/delete';

class MoreOptionsModal extends React.Component {

    render() {
        return (
            <div className="more-options-container">
                <TooltipDropdownMenu>
                    <ul>
                        {
                            this.props.showEdit &&
                            <li onClick={() => {
                                this.props.onClickMoreOption('edit')
                            }}>
                                <div className="button-text-wrapper">
                                    <EditIcon/>
                                    <label>Edit</label>
                                </div>
                            </li>

                        }
                        <li onClick={() => {
                            this.props.onClickMoreOption('delete')
                        }}>
                            <div className="button-text-wrapper">
                                <DeleteIcon/>
                                <label>Delete</label>
                            </div>
                        </li>
                    </ul>
                </TooltipDropdownMenu>
            </div>
        )
    }
}

export default MoreOptionsModal;